import { Injectable } from '@angular/core';

const sessionIdKey = 'sessionId';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor() { }

  getSessionId(): string {
    return localStorage.getItem(sessionIdKey);
  }

  setSessionId(sessionId: string, overwrite: boolean = false) {
    if (overwrite || !this.getSessionId()) {
      localStorage.setItem(sessionIdKey, sessionId);
    }
  }
}
